import { IVR_URLS } from "../../services/apiConfig.js";
//import { ASSIGNMENT_ERRORS } from "../../common/constants/ivrModule/assignmentConstants.js";
import apiClient from "../apiInstance.js";

export const initiateCall = async ({ customerConnectionId, agentAcsId }) => {
    return apiClient.post(IVR_URLS.IVR_INITIATE_CALL, {
      customerConnectionId,
      agentAcsId,
    });
  };

  export const getserverCall= async ({ refcustomerAcsId }) => {
    try {
        const response = await apiClient.post(IVR_URLS.IVR_SERVERID_CALL, {
          refcustomerAcsId
        });
        console.log ("data coming from:", response.data)
        return response.data;
        
    } catch (error) {
        console.error("error:", error);
        throw error;
    }
};